/**
 * Offsets hash-link scrolling for the fixed header.
 */
document.addEventListener('DOMContentLoaded', function() {
  // Check if there's a hash in the URL

  if (window.location.hash) {
    console.log('Hash found in URL:', window.location.hash);
    var targetId = window.location.hash.substring(1);
    var targetElement = document.getElementById(targetId);
    var offsetEnabled = targetElement.getAttribute('data-offset-enabled');
    if (targetElement && offsetEnabled) {

      console.log('data-offset-enabled value:', offsetEnabled);
      // Use a timeout to let the page finish rendering
      setTimeout(function() {
      var offset = window.innerWidth <= 768 ? 75 : 150;
 // The number of pixels to offset
        var elementPosition = targetElement.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth" // Optional: use smooth scrolling
        });
      }, 100);
    }
  }
});